export default __webpack_public_path__ + "static/media/gettingStartedStep1.415b396b.png";